import React from 'react'
import { useTable, usePagination, useSortBy } from 'react-table'
import { TableHeader } from './table-header.component'

const TableReviews = ({ columns, data, divided = false, defaultPageSize = 300 }: any) => {
  const {
    getTableProps,
    getTableBodyProps,
    prepareRow,
    headerGroups,
    page,
    state: { pageIndex, pageSize },
  }: any = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: defaultPageSize } as any,
    },
    useSortBy,
    usePagination,
  )

  return (
    <>
      <table {...getTableProps()} className={`r-table table${divided ? ' table-divided' : ''}`}>
        <thead>
          {headerGroups.map((headerGroup: any, headerGroupIndex: any) => (
            <tr {...headerGroup.getHeaderGroupProps()} key={`tr_${headerGroupIndex}`}>
              {headerGroup.headers.map((column: any, columnIndex: any) => (
                <TableHeader column={column} key={`th_${columnIndex}`} />
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {page.map((row: any, i: any) => {
            prepareRow(row)
            const rowIndex = pageIndex * pageSize + i
            return (
              <React.Fragment key={`tr-${rowIndex}`}>
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell: any, cellIndex: any) => (
                    <td
                      key={`td_${cellIndex}`}
                      {...cell.getCellProps({
                        className: cell.column.cellClass,
                      })}
                    >
                      {cell.render('Cell')}
                    </td>
                  ))}
                </tr>
              </React.Fragment>
            )
          })}
        </tbody>
      </table>
    </>
  )
}

export { TableReviews }
